import { render, staticRenderFns } from "./InactiveAPI.vue?vue&type=template&id=010e3e05&scoped=true"
import script from "./InactiveAPI.vue?vue&type=script&lang=js"
export * from "./InactiveAPI.vue?vue&type=script&lang=js"
import style0 from "./InactiveAPI.vue?vue&type=style&index=0&id=010e3e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e3e05",
  null
  
)

export default component.exports